// extracted by mini-css-extract-plugin
export default {"BrandKit":"styles_BrandKit__NODrf"};